import {Type} from "class-transformer";
import {ApprovalStatusType} from "@app/shared/enums/approval-status-type.enum";
import {serializeType} from "@app/shared/classes/common";
import {Transaction} from "@app/shared/enums/txn-type.enum";
import {ChargeCode} from "@app/shared";

export class ChargeCodeAuthLineitem {
  id: number;
  version: number;
  noHourLimit: boolean = false;
  authorizeEntireTeam: boolean = false;
  authorizedHours: number;
  authorizedFrom: string;
  authorizedThru: string;
  authorizedUserId: number;
  authorizedGroupId?: number;
  authorizedMemberId?: number;
  authorizedProjectId?: number;
  authorizedTaskId?: number;
  authorizedResourceId?: number;
  chargeCodeAuthId?: number;

  // display fields
  authorizedUserName?: string;
  authorizedUserType?: string;
  laborCategory?: string;
  ownerName?: string;
  projectAndTaskName?: string;
  teamName?: string;
  budgetHours?: number;
}

export class ChargeCodeAuth {
  id: number;
  version?: number;
  transaction: Transaction;
  allowAllAccess: boolean = false;
  disableAllAccess: boolean = false;
  enableNotification: boolean = false;

  hasSubmissionError?: boolean;
  processed?: boolean;

  daysUntilExpiration: number;
  percentHoursThreshold: number;
  chargeCode?:ChargeCode;
  chargeCodeId?: number;
  @Type(serializeType(ChargeCodeAuthLineitem)) chargeCodeAuthLineitems?: ChargeCodeAuthLineitem[];

  chargeNumber?: string;
  ownerName?: string;
  activityDescription?: string;
  userToNotifyId: number;
  userToNotifyName: string;

  currentStatus?: ApprovalStatusType;
  approvedBy?: string;
  approvedOn?: Date;
  responseMessage?: string;

  submittedById?: number;
  submittedForId?: number;

  // for PDF
  projectAndTaskName?: string;
  effectiveFrom?: string;
  effectiveThru?: string;
  pdfTemplateId?: number;

  constructor() {
    this.chargeCodeAuthLineitems = [];
  }
}
